module.exports = __webpack_public_path__ + "img/sample-img.1aeb756e.jpg";